module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "google"
  }, [_c('a', {
    attrs: {
      "href": _vm.loginRoute
    }
  }, [_vm._v("Sign in with Google")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f629efa"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/GoogleBtn/GoogleBtn.pug
// module id = 189
// module chunks = 1